import React, { useEffect, useState } from 'react';

// import './Counter.css';

const Counter = props => {

	const {
		count,
		hideAnimation
	} = props;

	const [displayCount, setDisplayCount] = useState(count);
	const [diff, setDiff] = useState(1);
	const [isIncrement, setIsIncrement] = useState(null);

	let timer = null;

	const pause = delay => {
		const now = Date.now();

		while (Date.now() < (now+delay)){}
	}

	const incDecCount = (num1, num2) => {

		// pause(100);

		if (num1 > num2) {
			return num1 - 1;
		}

		if (num1 < num2) {
			return num1 + 1;
		}
	}

	const counterClassName = (isIncrement===null && " ") || (isIncrement ? " inc" : " dec");

	useEffect(()=>{
		if ( hideAnimation ){
			setDisplayCount(count);
		} else {

			if (count !== displayCount) {
	
				if (diff === 1) {
					setDiff(Math.floor(count-displayCount));
					setIsIncrement((count-displayCount===0 && null) || count-displayCount > 0);
				}
	
				window.clearTimeout(timer);
				timer = window.setTimeout(()=>{
					setDisplayCount(incDecCount(displayCount, count));
				}, Math.abs(500/diff));
			} else {
				setDiff(1);
				setIsIncrement(null);
			}
		}
		
		return ()=>{window.clearTimeout(timer)}
	}, [count, displayCount]);

	return (
		<span className={"counter" + counterClassName}>
			{displayCount}
		</span>
	);
}

export default Counter;


// WEBPACK FOOTER //
// ./src/components/Counter.jsx